<template>
  <div>
    <div class="card">
      <header class="header-card">
        <p>{{ $t('addEditAudit.infoGenerale.title')}}</p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-3">
            <b-field class="obligatoire"
                     :label="$t('addEditAudit.infoGenerale.titre')">
              <b-input v-model="audit.titre">
              </b-input>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field class="obligatoire"
                     :label="$t('addEditAudit.infoGenerale.dateSouhaite')">
              <b-datepicker show-week-number
                            nearby-selectable-month-days
                            v-model="audit.dateSouhaitee"
                            icon="calendar-today"
                            :editable="true">
              </b-datepicker>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field
              :label="$t('addEditAudit.infoGenerale.datePlanification')">
              <b-datepicker show-week-number
                            nearby-selectable-month-days
                            v-model="audit.datePlanification"
                            icon="calendar-today"
                            :editable="true">
              </b-datepicker>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field :label="$t('addEditAudit.infoGenerale.dateRealisation')">
              <b-datepicker show-week-number
                            nearby-selectable-month-days
                            v-model="audit.dateRealisation"
                            icon="calendar-today"
                            :editable="true">
              </b-datepicker>
            </b-field>
          </div>
          <div class="column is-3">
            <user-autocomplete
              v-model="audit.auditeurId"
              :label="$t('addEditAudit.infoGenerale.auditeur')"
              obligatoire
            />
          </div>
          <div class="column is-3" v-if="agencesSelectionnees.length > 1">
            <b-field class="obligatoire"
                     :label="$t('addEditAudit.infoGenerale.agence')">
              <b-select v-model="audit.agenceId" expanded>
                <option :key="agence.agenceId"
                        :value="agence.agenceId"
                        v-for="agence in agencesSelectionnees">
                  {{ agence.libelleAgence }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-12">
            <b-field
              :label="$t('addEditAudit.infoGenerale.description')">
              <b-input v-model="audit.description" type="textarea">
              </b-input>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>
          {{ $t('addEditAudit.infoGenerale.pj')}}
        </p>
      </header>
      <div class="card-content">
        <piecesJointes :checkPermissions="true"/>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import piecesJointes from '@/components/general/piecesJointes';
import userAutocomplete from '@/components/commun/user/userAutocomplete';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'LogistiqueAuditEditAudit',
  props: {
    audit: {
      type: Object,
      required: true,
    },
  },
  components: {
    piecesJointes,
    userAutocomplete,
  },
  computed: {
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
    }),
  },
};

</script>
